// Package Imports
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { from } from 'rxjs';

// Services
import { AuthorizationService } from '../../services/authorization/authorization.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {
  constructor(private readonly router: Router,
              private readonly authorizationService: AuthorizationService,
              private readonly sessionService: SessionService) { }

  ngOnInit() {
    const failTime = 10000;
    const waitTime = 500;
    let elapsedTime = 0;

    this.authorizationService.completeAuthentication().then(() => {
      const intId = setInterval(() => {
        elapsedTime = elapsedTime + waitTime;

        if (elapsedTime > failTime) {
          this.router.navigate(['/unauthorized/408']);

          clearInterval(intId);
        }

        from(this.authorizationService.isLoggedIn()).subscribe(r => {
          if (r) {
            const keepAliveReq = this.sessionService.getSessionData(this.sessionService.sessionKey_KeepSessionAlive);

            if (keepAliveReq) {
              this.router.navigate([`/keepsessionalive`]);
            }
            else {
              this.router.navigate([`/home`]);
            }

            clearInterval(intId);
          }
        });
      }, waitTime);
    });
  }
}
